import { Button } from "primereact/button";

import commonStyle from "../content/CommonStyles.module.css";
import { Toolbar } from "primereact/toolbar";

const CommonToolbar = ({ isMobile, isFinalized, onRetunButtonClick, leftContent, onDocPrint, loading, additionalButtons }) => {

    const mainToolbarRightTemplate = () => {
        return (<>
            <div className="flex flex-wrap gap-2">
                {additionalButtons}
                {onDocPrint && <Button icon="pi pi-print" severity="secondary" onClick={onDocPrint} type="button" outlined/>}
                {!isFinalized && <Button icon={`${isMobile ? "pi pi-save" : ""}`} label={`${isMobile ? "" : "Зберегти"}`} severity="success" loading={loading} className={commonStyle.addButton} type="submit" />}
                <Button icon={`${isMobile ? "pi pi-sign-out" : ""}`} label={`${isMobile ? "" : "Вийти"}`} severity="secondary" className={commonStyle.closeButton} type="button" onClick={onRetunButtonClick} />
            </div>
        </>);
    }

    return (<Toolbar className="mb-4" start={leftContent} end={mainToolbarRightTemplate} />)
}

export default CommonToolbar;